import React from 'react'

const CopyIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="17" viewBox="0 0 14 17" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M13.7982 1.79962C13.7982 0.805719 12.9925 0 11.9985 0H4.80006C3.80616 0 3.00044 0.805719 3.00044 1.79962V12.1974C3.00044 13.1913 3.80616 13.997 4.80006 13.997H11.9985C12.9925 13.997 13.7982 13.1913 13.7982 12.1974V1.79962Z" fill="#676767" />
            <path d="M1.67465 3.01113L1.6724 4.70914V13.1107C1.6724 14.5464 2.83622 15.7102 4.27186 15.7102L11.1634 15.7104C10.9163 16.4093 10.2498 16.9099 9.46629 16.9099H4.27186C2.17362 16.9099 0.472656 15.209 0.472656 13.1107V4.70914C0.472656 3.92474 0.974507 3.25755 1.67465 3.01113Z" fill="#676767" />
        </svg>
    )
}

export default CopyIcon